import { Flash, Box, Button } from '@acast/decibel';
import T from 'prop-types';
import React, { Component } from 'react';
import { impersonateUser } from 'services/authentication';
import { dismissModal, presentModal } from 'services/modals';
import Modal from 'shared/components/modal';
import UserSearch from '../components/user-search-input';
import getTokenForUser from '../helpers/get-token-for-user';

class ImpersonateUserDialog extends Component {
  static propTypes = {
    onDismiss: T.func.isRequired,
  };

  state = {
    user: null,
    error: null,
    fetchToken: null,
  };

  onUserFound = id => {
    this.clearTokenRequest({ user: id });
  };

  onUserNotFound = () => {
    this.clearTokenRequest({ user: null });
  };

  getErrorMessage() {
    const { error } = this.state;
    if (error === null) {
      return null;
    }
    return <Flash intent="danger">{error}</Flash>;
  }

  clearTokenRequest = (stateChanges = {}) => {
    return new Promise((resolve, reject) => {
      try {
        this.setState(prev => {
          if (prev.fetchToken) {
            prev.fetchToken.abort();
          }
          return { fetchToken: null, ...stateChanges };
        }, resolve);
      } catch (e) {
        this.setState({ error: e });
        reject(e);
      }
    });
  };

  createTokenRequest = () => {
    this.setState(prev => {
      if (prev.user === null) {
        return prev;
      }

      const fetchToken = getTokenForUser(prev.user, (err, result) => {
        if (err) {
          this.clearTokenRequest({ error: err });
        } else {
          impersonateUser({
            token: result.token,
            expires: result.expires,
            userId: prev.user,
          });
        }
      });

      return {
        fetchToken,
      };
    });
  };

  fetchUserToken = () => {
    this.clearTokenRequest().then(this.createTokenRequest);
  };

  render() {
    const { onDismiss } = this.props;
    const { user, fetchToken } = this.state;
    const isUserValid = user !== null;
    const isTokenPending = fetchToken !== null;

    return (
      <div className="impersonate-user-dialog">
        <UserSearch
          onUserFound={this.onUserFound}
          onUserNotFound={this.onUserNotFound}
          disabled={isTokenPending}
        />
        <br />
        <Box justifyContent="flex-end" gap={2}>
          <Button variant="tertiary" onClick={onDismiss} disabled={isTokenPending}>
            Dismiss
          </Button>
          <Button
            variant="primary"
            intent="danger"
            disabled={!isUserValid}
            onClick={this.fetchUserToken}
            busy={isTokenPending}
          >
            Impersonate
          </Button>
        </Box>
      </div>
    );
  }
}

export default () => {
  const modalId = 'admin-tools/impersonate-user';

  presentModal(
    <Modal
      id={modalId}
      title="Impersonate User"
      dialog={
        <ImpersonateUserDialog
          onDismiss={() => {
            dismissModal(modalId);
          }}
        />
      }
      actions={[]}
    />
  );
};
